import { Form } from 'antd'
import styled from 'styled-components'

export const StyledForm = styled(Form)`
	width: 100%;
	max-width: 1024px;
	display: flex;
	flex-direction: column;
	gap: 16px;
	background-color: white;
	padding: 16px;
	border-radius: 4px;
`

export const StyledFormItem = styled(Form.Item)`
	margin: 0;
`
